import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SellersService, Seller } from 'src/app/core/sellers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { I18N_DEFAULT_PREFIX_COUNTRY, I18N_UNKNOWN_FLAG } from 'src/app/shared/constants/operationals';
import { Observable, map, startWith } from 'rxjs';
import { CountriesService, Country } from 'src/app/core/countries.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-sellers-set-phone-dialog',
  templateUrl: './sellers-set-phone-dialog.component.html',
  styleUrls: ['./sellers-set-phone-dialog.component.scss'],
})
export class SellersSetPhoneDialogComponent {
  seller?: Seller;
  seller_edit_phone_form_group: FormGroup = this.form_service.seller_set_phone_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_seller_edit_running: boolean = false;
  country_prefixes?: Country[];
  current_country_prefix?: Country;
  filtered_prefixes?: Observable<Country[] | undefined>;
  unknown_flag_src: string = I18N_UNKNOWN_FLAG;

  constructor(
    private form_service: FormService,
    private dialog_ref: MatDialogRef<SellersSetPhoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private sellers_service: SellersService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
    private countries_service: CountriesService,
  ) {
    this.seller = data.seller;
  }

  ngOnInit(): void {
    this.seller_edit_phone_form_group.get(this.form_service.phone_value_label)?.setValue(this.seller?.phone.value);
    this.seller_edit_phone_form_group.get(this.form_service.phone_prefix_label)?.setValue(this.seller?.phone.prefix);

    this.country_prefixes = this.countries_service.getCountryPrefixList();
    this.filtered_prefixes = this.seller_edit_phone_form_group
      ?.get(this.form_service.phone_prefix_label)
      ?.valueChanges.pipe(
        startWith(''),
        map(value => this.filterPrefix(value || '')),
      );
    this.setPrefix(I18N_DEFAULT_PREFIX_COUNTRY);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onCountryPrefixSelect(): void {
    if (this.country_prefixes) {
      const code: string = this.seller_edit_phone_form_group.get(this.form_service.phone_prefix_label)?.value;
      this.setPrefix(code);
    }
  }

  onConfirmClick(): void {
    if (this.isFormValid() && this.seller?.seller_id) {
      this.seller.phone.prefix = this.seller_edit_phone_form_group.get(this.form_service.phone_prefix_label)?.value;
      this.seller.phone.value = this.seller_edit_phone_form_group.get(this.form_service.phone_value_label)?.value;

      this.setPhone(this.seller);
    }
  }

  setPhone(seller: Seller): void {
    this.is_seller_edit_running = true;
    this.sellers_service.setPhone(seller).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_seller_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_seller_edit_running = false;
      },
    });
  }

  setPrefix(code: string): void {
    if (this.country_prefixes) {
      this.current_country_prefix = this.utils_service.getCountryPrefixFromCode(this.country_prefixes, code);
      this.seller_edit_phone_form_group
        .get(this.form_service.phone_prefix_label)
        ?.setValue(this.current_country_prefix.prefix);
    }
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.seller_edit_phone_form_group);
  }

  filterPrefix(value: string): Country[] | undefined {
    const filter_value = value.toLowerCase();
    return this.country_prefixes?.filter(option => {
      return option.prefix.toLowerCase().includes(filter_value);
    });
  }
}
